import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormik } from "formik";

import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import { Panel, PanelBody, PanelHeader } from "../../../panel/panel.jsx";
import Title from "../../../Title.tsx";
import Layout from "../../../Layout.tsx";
import { RootState } from "../../../../store/index.ts";
import { ReporteRelojChecadorDefaultValues } from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import ReporteRelojChecadorForm from "../../../../forms/ReporteRelojChecadorForm.tsx";
import { readBranches } from "../../../../services/branch.service.ts";
import Branch from "../../../../models/Branch.ts";
import ReporteRelojChecadorSchema from "../../../../validation/schemas/ReporteRelojChecadorSchema.ts";
import TableDiasDescanso, {
  RestDayDayRecord,
} from "./TableDiasDescanso.tsx";
import { findPartnersRestDay } from "../../../../services/branchSchedule.service.ts";

const DiasDescanso = () => {
  useAppSettings();
  const { id } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const [branchs, setBranchs] = useState([]);
  const [title, setTitle] = useState("Días de descanso");
  const [records, setRecords] = useState<RestDayDayRecord[]>([]);
  const [loading, setLoading] = useState(true);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: ReporteRelojChecadorDefaultValues(),
    validationSchema: ReporteRelojChecadorSchema,
    onSubmit: async (values) => {
      setRecords([]);
      setLoading(true);
      try {
        const { branch, partner, start, end } = values;
        if (formik.values.branch !== -99) {
          const branchRow = branchs.find(
            (b: Branch) => Number(b.id) === Number(formik.values.branch)
          ) as Branch | undefined;
          if (branchRow?.name) {
            setTitle(`Días de descanso - ${branchRow.name}`);
          } else if (Number(formik.values.branch) === 0) {
            setTitle("Días de descanso - Todas las sucursales");
          }
        }

        const data = await findPartnersRestDay(branch, partner, start, end);
        setRecords(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchDependencies = async () => {
    const number =
      user?.rol === "Lider de sucursal" ? Number(user.branchId) : Number(id);
    try {
      const branches = await readBranches();
      const branch = branches.find(
        (b: Branch) => Number(b.id) === number
      );
      setTitle(`Días de descanso - ${branch?.name || ""}`);
      await formik.setFieldValue("branch", branch?.id ?? -99);
      setBranchs(branches);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user) {
      fetchDependencies();
    }
  }, [user]);

  useEffect(() => {
    if (branchs.length > 0) {
      formik.handleSubmit();
    }
  }, [branchs, id]);

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Sucursales"
        basePath="/sucursales"
        activeTitle="Días de descanso"
        title={title}
      />

      <div className="card border-0 m-4 rounded">
        <Panel>
          <PanelHeader noButton={true} className="bg-azul">
            Formulario para el reporte
          </PanelHeader>
          <PanelBody>
            <ReporteRelojChecadorForm
              formik={formik}
              branches={branchs}
              disabled={user?.rol === "Lider de sucursal"}
              handleDownload={() => {}}
            />
          </PanelBody>
        </Panel>
      </div>

      <div className="card border-0 m-4 rounded">
        <div className="tab-content p-3">
          <TableDiasDescanso records={records} loading={loading} />
        </div>
      </div>
    </Layout>
  );
};

export default DiasDescanso;
